import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
import { v4 as uuid } from 'uuid';

export class BidPipeLiquidBus extends BaseBus{

    constructor(busObj: BidPipeLiquidBus) {
        super(busObj);

    }
    // CID(): any {
    //     return this.bidPipeLiquidID;
    // }
    // setId(id: any) {
    //     this.bidPipeLiquidID = id;
    // }
    // setParentId(id: any) {
    //     this.bidSheetDetailId = id;
    // }
    // initialize(data: BidPipeLiquidBus) {
    //     super.initialize(data);
    //     this.insertDt = CommonFunctions.getDate(data.insertDt);
    //     this.updateDt = CommonFunctions.getDate(data.updateDt);
    // }
    // setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    // }
    // setFromForm(data: BidPipeLiquidBus) {
    //     super.setFromForm(data);
    //     let dateNow = CommonFunctions.getDateNow();

    //     if (this.hasId) {
    //         this.insertDt = data.insertDt;
    //         this.insertUserId = data.insertUserId;
    //     }
    //     else {
    //         this.insertDt = dateNow;
    //         this.insertUserId = data.insertUserId;
    //     }

    // }
    // setBeforeSave() {
    //     this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
    //     this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    // }
    // setCommon(userId: any, date: Date, companyId: any = null) {
    //     this.updateDt = date;
    //     if (this.hasId) {
    //         this.updateUserId = userId;

    //     }
    //     else {
    //         this.insertDt = date;
    //         this.insertUserId = userId;
    //          this.updateUserId = userId;
    //     }
    // }
    //#region When Same Component are to be use for both liquid and Suction
        // bidPipeLiquidID: string;
        // bidSheetDetailId: string;
        // system : string;
        // pipeSizeId : string;
        // pipeLF :number;
        // copperTypeID : string;
        // refrigerant :number;
        // thicknessID : string;
        // insulationcolorId : string;
        // insertDt :Date;
        // insertUserId : string;
        // updateDt :Date;
        // updateUserId : string;
        // pipeSizeValue : string;
        // pipeTypeValue : string;
        // thickValue : string;
        // insuColorValue : string;
        //#endregion

    CID(): any {
        return this.bidPipeLinesId;
    }
    setId(id: any) {
        this.bidPipeLinesId = id;
    }
    setParentId(id: any) {
        this.bidSheetDetailId = id;
    }
    initialize(data: BidPipeLiquidBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: BidPipeLiquidBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

        //#region New With one Table
        bidPipeLinesId :string;
        bidSheetDetailId :string;
        system :string;
        llPipeSizeId :string;
        llPipeLF :number;
        llCopperTypeID :string;
        llRefrigerant :number;
        llThicknessID :string;
        llInsulationcolorId :string;
        slPipeSizeId :string;
        slPipeLF :number;
        slCopperTypeID :string;
        slRefrigerant :number;
        slThicknessID :string;
        slInsulationcolorId :string;
        insertDt :Date;
        insertUserId :string;
        updateDt :Date;
        updateUserId :string;
        llPipeSizeValue :string;
        llPipeTypeValue :string;
        llThickValue :string;
        llInsuColorValue :string;
        slPipeSizeValue :string;
        slPipeTypeValue :string;
        slThickValue: string;
        slInsuColorValue: string;
        systemDesc : string;
        //#endregion

}
export class nullBidPipeLiquidBus {
    constructor(systemCount: string){
        this.bidPipeLinesId = uuid();
        this.system = systemCount;
    }
    public bidPipeLinesId =null;
    public bidSheetDetailId =null;
    public system =null;
    public llPipeSizeId =null;
    public llPipeLF =null;
    public llCopperTypeID =null;
    public llRefrigerant  =null;
    public llThicknessID  =null;
    public llInsulationcolorId  =null;
    public slPipeSizeId =null;
    public slPipeLF =null;
    public slCopperTypeID =null;
    public slRefrigerant  =null;
    public slThicknessID  =null;
    public slInsulationcolorId  =null;
    public insertDt =null;
    public insertUserId =null;
    public updateDt =null;
    public updateUserId =null;
    public llPipeSizeValue  =null;
    public llPipeTypeValue  =null;
    public llThickValue =null;
    public llInsuColorValue =null;
    public slPipeSizeValue  =null;
    public slPipeTypeValue  =null;
    public slThickValue =null;
    public slInsuColorValue =null;
    public systemDesc =null;
  }